<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-sigma</v-icon>
          סה״כ
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-data-table
          :items="totals"
          :headers="headers"
          sort-by="store"
        >
          <!-- <template v-slot:group="{ group }">
            {{ group }}
          </template> -->
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fetching: false,
      headers: [
        { text: "חנות", value: "store" },
        { text: "מגירה", value: "boxType" },
        { text: "סה״כ מכשירים", value: "total" }
      ],
      options: {
        sortDesc: [false, false],
        sortBy: ["store", "boxType"]
      }
    };
  },
  methods: {
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    },
    storeById(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.title;
        }
      }
    },
    boxTypeById(id) {
      if (id) {
        let boxType = this.$store.state.entities.boxTypes[id];
        if (boxType) {
          return boxType.title;
        }
      }
    }
  },
  computed: {
    deliveryItems() {
      return Object.values(this.$store.state.entities.deliveryItems)
        .filter(item => {
          return item.delivery && item.delivery === this.delivery._id;
        })
        .sort((a, b) => {
          return a.store < b.store ? -1 : 1;
        });
    },
    totals() {
      let totals = [];
      let totalsMap = {};
      for (let deliveryItem of this.deliveryItems) {
        if (totalsMap[deliveryItem.store]) {
          if (totalsMap[deliveryItem.store][deliveryItem.boxType]) {
            totalsMap[deliveryItem.store][deliveryItem.boxType] += 1;
          } else {
            totalsMap[deliveryItem.store][deliveryItem.boxType] = 1;
          }
        } else {
          totalsMap[deliveryItem.store] = {};
          totalsMap[deliveryItem.store][deliveryItem.boxType] = 1;
        }
      }
      for (let [storeKey, storeValue] of Object.entries(totalsMap)) {
        for (let [boxTypeKey, total] of Object.entries(storeValue)) {
          totals.push({
            store: this.storeById(storeKey),
            boxType: this.boxTypeById(boxTypeKey),
            total
          });
        }
      }
      return totals;
    }
  },
  props: ["delivery"],
  watch: {},
  mounted() {},
  components: {},
  mixins: []
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>